<script lang="ts">
  import { Radio } from '@lucide/svelte';
  import * as Tooltip from '$lib/components/ui/tooltip/index.js';
  import { liveStream } from '$lib/liveStream/LiveStream';
  import { streamingState } from '$lib/liveStream/streamingState.svelte';
</script>

{#if streamingState.enabled}
  <Tooltip.Provider delayDuration={200}>
    <Tooltip.Root>
      <Tooltip.Trigger>
        <div
          class="flex items-center gap-1 rounded-md px-2 py-1 text-xs font-medium {liveStream.isConnected
            ? 'bg-green-100 text-green-700 dark:bg-green-900/40 dark:text-green-400'
            : 'bg-yellow-100 text-yellow-700 dark:bg-yellow-900/40 dark:text-yellow-400'}"
        >
          <Radio class="h-3.5 w-3.5 {liveStream.isConnected ? 'animate-pulse' : ''}" />
          <span>LIVE</span>
        </div>
      </Tooltip.Trigger>
      <Tooltip.Content>
        {liveStream.isConnected
          ? 'Streaming temperature data'
          : 'Streaming enabled, waiting for connection'}
      </Tooltip.Content>
    </Tooltip.Root>
  </Tooltip.Provider>
{/if}
